import {Component, OnInit} from '@angular/core';
import {BreadcumbsService} from './breadcumbs.service';
import { TopMenuService } from '../top-menu/top-menu.service';

@Component({
    selector: 'pbc-breadcumbs',
    templateUrl: './breadcumbs.component.html',
    styleUrls: ['./breadcumbs.component.scss']
})

export class BreadcumbsComponent implements OnInit {
    public strSubfolder: string = '';

    constructor(private breadcumbsService: BreadcumbsService, private topMenuService: TopMenuService) {
    }
    
    public onGoHome(){
        this.topMenuService.setActiveMenuPosition(0)
    }

    ngOnInit() {
        this.strSubfolder = '';
        this.breadcumbsService.setSubfolder.subscribe((result: string) => {
            if (result) {
                if (result !== 'Previous') {
                    this.strSubfolder = result;
                    localStorage.setItem('LastSubReport', result);
                } else {
                    if (localStorage.getItem('LastSubReport') ){
                        this.strSubfolder = localStorage.getItem('LastSubReport');
                    }
                }
            }
        });
    }

}
